export enum ObjetivoProgramaEnum {
    SECAGEM = 'secagem',
    RESFRIAMENTO = 'resfriamento',
    CONSERVACAO = 'conservacao',
    RESFRIAMENTO_E_CONSERVACAO = 'resfriamento_e_conservacao',
    CORRETIVA = 'corretiva',
}
